const GoogleIcon = ({ size = 18 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3981 9.19953C17.3981 8.57921 17.3425 7.98276 17.2391 7.41016H9V10.7941H13.708C13.5052 11.8876 12.8889 12.8141 11.9624 13.4344V15.6293H14.7896C16.4438 14.1064 17.3981 11.8637 17.3981 9.19953Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99726 17.7422C11.3592 17.7422 13.3395 16.9588 14.7869 15.6228L11.9597 13.4278C11.1763 13.9527 10.1743 14.2628 8.99726 14.2628C6.71879 14.2628 4.79025 12.724 4.10233 10.6562H1.17969V12.9228C2.61914 15.7818 5.57757 17.7422 8.99726 17.7422Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.10312 10.665C3.92816 10.1401 3.82875 9.57946 3.82875 9.00289C3.82875 8.42631 3.92816 7.86564 4.10312 7.34076V5.07422H1.18047C0.587993 6.25521 0.25 7.59127 0.25 9.00289C0.25 10.4145 0.587993 11.7506 1.18047 12.9316L4.10312 10.665Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99726 3.72934C10.2816 3.72934 11.4348 4.17072 12.3414 5.03757L14.8505 2.52847C13.3355 1.11685 11.3553 0.25 8.99726 0.25C5.57757 0.25 2.61914 2.21036 1.17969 5.06938L4.10233 7.33592C4.79024 5.2682 6.71879 3.72934 8.99726 3.72934Z"
      fill="#EA4335"
    />
  </svg>
);

export default GoogleIcon;
